import {defineStore} from "pinia";
import {IndexCompetition} from "@/types/Competition";
import {
    RegistrationsCalendarResponse,
    registrationsCalendarService
} from "@/modules/home/registrations/service/RegistrationsCalendarService";
import {useCalendarFilterStore} from "@/modules/home/filter/store/CalendarFilterStore";

export const useRegistrationsStore = defineStore('registrationsStore', {
    state: () => {
        return {
            loading: false,
            response: {closing: [], open: [], soon: []} as RegistrationsCalendarResponse,
            closing: [] as Array<IndexCompetition>,
            open: [] as Array<IndexCompetition>,
            soon: [] as Array<IndexCompetition>,
        }
    },
    getters: {
        hasCompetitions(): boolean {
            return (
                this.closing.length > 0 ||
                this.open.length > 0 ||
                this.soon.length > 0
            )
        }
    },
    actions: {
        reload() {
            this.startLoading()
            Promise.all([
                this.loadAll()
            ])
                .then(() => {
                    this.stopLoading()
                })
        },
        async loadAll() {
            this.response = await registrationsCalendarService.getCalendar(useCalendarFilterStore().getFilterContext)
            this.updateFilteredItems()
        },
        updateFilteredItems() {
            const keyword = useCalendarFilterStore().keyword
            if (keyword && keyword != "") {
                this.closing = this.response.closing.filter(it => this.filterItem(it, keyword))
                this.open = this.response.open.filter(it => this.filterItem(it, keyword))
                this.soon = this.response.soon.filter(it => this.filterItem(it, keyword))
            } else {
                this.closing = this.response.closing
                this.open = this.response.open
                this.soon = this.response.soon
            }
        },
        startLoading() {
            this.loading = true
        },
        stopLoading() {
            this.loading = false
        },
        filterItem(item: IndexCompetition, term: string): boolean {
            return item.name.toLowerCase().includes(term.toLowerCase())
        }
    }
})